<template>
    <div class="map" id="map" style="width: 100%;height: 85vh;"></div>
</template>

<script>
    import {map} from "../../api/userMG";

    export default {
        data() {
            return {
                loading: false, //是显示加载
                editFormVisible: false, //控制编辑页面显示与隐藏
                operatorVisible: false, //控制操作员页面显示与隐藏
                formInline: {
                    page: 1,
                    limit: 10,
                    pageSize: 10
                },
                status: [],
                devices: [],
                data: [],
                names: [],
                information: [],
                statusData: ["leave", "stop", "run", "alarm"],
                statusData1: ["离线", "停止", "运行", "报警"],
                listData: [], //用户数据
            }
        },
        /**
         * 创建完毕
         */
        created() {
            this.getdata(this.formInline)
        },

        /**
         * 里面的方法只有被调用才会执行
         */
        methods: {
            getdata(parameter) {
                let t = this
                t.loading = true
                map(parameter).then(res => {
                    t.data = res.data.arr
                    t.zoom = res.data.zoom
                    t.status = res.data.status
                    t.names = res.data.names
                    t.devices = res.data.devices
                    t.information = res.data.infos

                    let latlngs = []
                    let center = new qq.maps.LatLng(t.data[0][0], t.data[0][1])
                    let map = new qq.maps.Map(document.getElementById("map"), {
                        center: center,
                        zoom: this.zoom
                    });
                    let infoWin = new qq.maps.InfoWindow({
                        map: map,
                    });
                    this.data.forEach((item) => {
                        latlngs.push(new qq.maps.LatLng(item[0], item[1]))
                    })

                    let anchor = new qq.maps.Point(25, 0),
                        size = new qq.maps.Size(60, 100),
                        origin = new qq.maps.Point(0, 0)
                    //根据图片大小调整 界点
                    for (var i = 0; i < latlngs.length; i++) {
                        (function (n) {
                            //实例标注
                            var marker = new qq.maps.Marker({
                                position: latlngs[n],
                                map: map
                            });

                            //设置每个标注的样式
                            marker.setIcon(new qq.maps.MarkerImage(
                                '/static/images/location-' + t.statusData[t.status[n]] + '.png'
                                , size, origin, anchor
                            ));

                            let infoHtml = "<div class='device-info' style='width: 300px;margin-top: 10px;display: flex;'><p style='float: left;width: 50%;'>设备名称：</p><p style='float: right;width: 50%;text-align: right;'>" + t.names[n] + "</p></div>" +
                                "<div class='device-info' style='width: 300px;display: flex;'><p style='float: left;width: 50%;'>设备状态：</p><p style='float: right;width: 50%;text-align: right;'>" + t.statusData1[t.status[n]] + "</p></div>" +
                                "<div class='device-info' style='width: 300px;display: flex;'><p style='float: left;width: 50%;'>电压显示：</p><p style='float: right;width: 50%;text-align: right;'>" + t.information[n][0] + " v</p></div>" +
                                "<div class='device-info' style='width: 300px;display: flex;'><p style='float: left;width: 50%;'>水压显示：</p><p style='float: right;width: 50%;text-align: right;'>" + t.information[n][1] + " Mpa</p></div>" +
                                "<div class='device-info' style='width: 300px;display: flex;'><p style='float: left;width: 50%;'>电流显示：</p><p style='float: right;width: 50%;text-align: right;'>" + t.information[n][2] + " A</p></div>" +
                                "<div class='device-info' style='width: 300px;display: flex;'><p style='float: left;width: 50%;'>下次维保：</p><p style='float: right;width: 50%;text-align: right;'>" + t.information[n][3] + " h</p></div>" +
                                "<div class='device-info' style='width: 300px;display: flex;'><p style='float: left;width: 50%;'>累计运行：</p><p style='float: right;width: 50%;text-align: right;'>" + t.information[n][4] + " h</p></div>";

                            //标注点击事件
                            qq.maps.event.addListener(marker, 'click', function () {
                                infoWin.open();
                                infoWin.setContent(infoHtml);
                                infoWin.setPosition(latlngs[n]);
                            });
                        })(i);
                    }
                })
            },
        }
    }
</script>
<style scoped>
    .device-info{
        width: 10rem;
    }
</style>


// WEBPACK FOOTER //
// src/views/Spread/Spread.vue